exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#basicSelect{height:33px}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/Partials/ChangeLanguages.vue"],"names":[],"mappings":"AACA,aACE,WAAa,CACd","file":"ChangeLanguages.vue","sourcesContent":["\n#basicSelect {\n  height: 33px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c422fd5a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Partials/ChangeLanguages.vue
// module id = 1374
// module chunks = 0